import MyOrdersListing from "pages/userDashboard/pages/myOrders/MyOrdersListing";
import BookOrdersListing from "../pages/userDashboard/pages/bookOrders/BookOrdersListing";
import OrderSummary from "../pages/userDashboard/pages/bookOrders/orderSummary/OrderSummary";
import DashboardHomeUser from "../pages/userDashboard/pages/dashboardHome/DashboardHome";
import UserSettings from "../pages/userDashboard/pages/settings/Settings";
import ViewMyOrderDetails from "pages/userDashboard/pages/myOrders/ViewMyOrderDetails";
import MyOrderReview from "pages/userDashboard/pages/myOrders/MyOrderReview";
import PaymentListing from "pages/userDashboard/pages/payment/PaymentListing";
import InvoicesLIsting from "pages/userDashboard/pages/invoices/InvoicesLIsting";
import TrackOrder from "pages/userDashboard/pages/trackOrder/TrackOrder";
import DownloadPOD from "pages/userDashboard/pages/downloadPOD/DownloadPOD";
import WeightDiscrepancies from "pages/userDashboard/pages/weightDiscrepancies/WeightDiscrepancies";
import BulkOrder from "pages/userDashboard/pages/bulkOrder/BulkOrder";
import StandardRates from "pages/userDashboard/pages/onboarding/StandardRates";
import MyContract from "pages/userDashboard/pages/contract/MyContract";

export const userRoutes = [
  {
    id: 901,
    path: "/user/dashboard/standard-rates",
    element: <StandardRates />,
    enabled: true,
  },
  {
    id: 902,
    path: "/user/dashboard/my-contract",
    element: <MyContract />,
    enabled: true,
  },
  {
    id: 1,
    path: "/user/dashboard/home",
    element: <DashboardHomeUser />,
    enabled: true,
  },
  {
    id: 2,
    path: "/user/dashboard/settings",
    element: <UserSettings />,
    enabled: true,
  },
  {
    id: 3,
    path: "/user/dashboard/book-orders",
    element: <BookOrdersListing />,
    enabled: true,
  },
  {
    id: 31,
    path: "/user/dashboard/book-orders/order-summery",
    element: <OrderSummary />,
    enabled: true,
  },
  {
    id: 4,
    path: "/user/dashboard/my-orders",
    element: <MyOrdersListing />,
    enabled: true,
  },
  {
    id: 401,
    path: "/user/dashboard/my-orders/details/:orderId",
    element: <ViewMyOrderDetails />,
    enabled: true,
  },
  {
    id: 402,
    path: "/user/dashboard/my-orders/review/:orderID",
    element: <MyOrderReview />,
    enabled: true,
  },
  {
    id: 501,
    path: "/user/dashboard/payments",
    element: <PaymentListing />,
    enabled: true,
  },
  {
    id: 601,
    path: "/user/dashboard/invoice",
    element: <InvoicesLIsting />,
    enabled: true,
  },
  {
    id: 701,
    path: "/user/dashboard/track-order",
    element: <TrackOrder />,
    enabled: true,
  },
  {
    id: 702,
    path: "/user/dashboard/download-pod",
    element: <DownloadPOD />,
    enabled: true,
  },
  {
    id: 801,
    path: "/user/dashboard/Weight-Discrepancies",
    element: <WeightDiscrepancies />,
    enabled: true,
  },
  {
    id: 901,
    path: "/user/dashboard/bulk-orders",
    element: <BulkOrder />,
    enabled: true,
  },
].filter((route) => route.enabled);
